document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  const floatingCheckout = document.querySelector('.floating-checkout-button');
  if (floatingCheckout) {
    const updateFloatingCheckout = () => {
      floatingCheckout.classList.toggle('is-visible', window.scrollY > 420);
    };
    updateFloatingCheckout();
    window.addEventListener('scroll', updateFloatingCheckout, { passive: true });
  }

  document.querySelectorAll('[data-plan-selector]').forEach((selector) => {
    const landing = selector.closest('.reference-landing');
    const options = Array.from(selector.querySelectorAll('[data-plan-option]'));
    const checkout = landing?.querySelector('[data-plan-checkout]');
    const floating = landing?.querySelector('[data-plan-floating]');

    const selectPlan = (selected) => {
      options.forEach((option) => {
        const active = option === selected;
        option.classList.toggle('is-selected', active);
        option.setAttribute('aria-pressed', String(active));
      });
      const url = selected.dataset.planUrl;
      const label = selected.dataset.planLabel;
      if (checkout) {
        checkout.href = url;
        checkout.textContent = label;
      }
      if (floating) {
        floating.href = url;
        floating.setAttribute('aria-label', label);
      }
    };

    options.forEach((option) => option.addEventListener('click', () => selectPlan(option)));
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-target]'));
    const previous = gallery.querySelector('[data-gallery-previous]');
    const next = gallery.querySelector('[data-gallery-next]');
    let current = 0;

    const showSlide = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        if (!active) slide.querySelector('video')?.pause();
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === current;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', String(active));
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => showSlide(Number(thumb.dataset.galleryTarget)));
    });
    previous?.addEventListener('click', () => showSlide(current - 1));
    next?.addEventListener('click', () => showSlide(current + 1));
  });
});
